import React, { Component } from 'react'
import DatePicker from 'react-datepicker';
import moment from "moment";
import 'react-datepicker/dist/react-datepicker.css';
import { Link } from 'react-router-dom'
import log from '../../../helpers/logger'
import { auth, getCurrentUser } from '../../../helpers/auth'
import { getTimeStamp, getUUIDV4 } from '../../../helpers/utils'
import {
  createPublisher,
  updatePublisher,
  getPublisher,
  deletePublisher } from '../../../services/PublisherService'

function setErrorMsg(error) {
  return {
    errorMsg: error.message
  }
}

export default class PublisherPageEdit extends Component {

  constructor(props) {
    super(props);
    this.state = {
      publisherId: null,
      publisher_uuid: '',
      owner_id: '',
      tag: '',
      title: '',
      description: '',
      date_created: null,
      status: '',

      errorMsg: null,
      currentUser: null,
      isLoading: true
    };

    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

  }

  componentWillMount() {
    log.debug('componentWillMount')
  }
  async componentDidMount(){
    log.debug('componentDidMount')
    let user = await getCurrentUser();
    this.setState({currentUser: user})

    // load info
    let publisher = await getPublisher(this.props.match.params.id)
    log.debug(publisher)

    this.setState({publisherId: this.props.match.params.id})
    this.setState({
      publisher_uuid: publisher.publisher_uuid === undefined ? '' : publisher.publisher_uuid,
      owner_id: publisher.owner_id === undefined ? '' : publisher.owner_id,
      tag: publisher.tag === undefined ? '' : publisher.tag,
      title: publisher.title === undefined ? '' : publisher.title,
      description: publisher.description === undefined ? '' : publisher.description,
      date_created: publisher.date_created === undefined ? '' : publisher.date_created,
      status: publisher.status === undefined ? '' : publisher.status
      })
    // setup for moment DatePicker
    this.setState({date_created: moment(publisher.date_created)})

    log.debug(this.state)

    log.debug('all data is loaded.')
    this.setState({isLoading: false})
  }

  handleDateChange(date) {
    this.setState({
      date_created: date
    });
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    // bind all input to setState
    this.setState({
      [name]: value
    });
    log.debug(this.state)

  }

  async handleSubmit(event) {
    event.preventDefault();

    log.debug(this.state.date_created.toDate())

    let publisher = {
      publisher_uuid: this.state.publisher_uuid,
      owner_id: this.state.owner_id,
      tag: this.state.tag,
      title: this.state.title,
      description: this.state.description,
      date_created: this.state.date_created.toDate(),
      status: this.state.status
    }
    log.debug(publisher)

    try{
      let result = await updatePublisher(this.state.publisherId, publisher)
      log.debug('update success')
      //redirect to view
      this.props.history.push(`/publisher/view/${this.state.publisherId}`)
    }catch (err) {
      log.debug(err)
      this.setState(setErrorMsg(err))
    }

  }

  render () {

    let content;

    if (this.state.isLoading) {
      content = <div>Loading...</div>;
    } else {
      content =
      <div>
        <h4 className="page-header">
          <Link to='/publisher'>Publisher</Link> -> &nbsp;
          <Link to={`/publisher/view/${this.state.publisherId}`}>{this.state.title}</Link>  ->&nbsp;
          Edit
        </h4>
        <form className="form-horizontal" role="form" onSubmit={this.handleSubmit}>

          {
            this.state.registerError &&
          <div className="form-group">
            <div className="col-sm-offset-2 col-sm-10">
              <div className="alert alert-danger" role="alert">
              <span className="sr-only">Error:</span>
              &nbsp;{this.state.registerError}
              </div>
            </div>
          </div>
          }

          <div className="form-group">
            <label htmlFor="publisher_uuid" className="col-sm-2 control-label">publisher_uuid:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="publisher_uuid"
                value={this.state.publisher_uuid}
                onChange={this.handleInputChange}
                placeholder="publisher_uuid" readOnly/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="owner_id" className="col-sm-2 control-label">owner_id:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="owner_id"
                value={this.state.owner_id}
                onChange={this.handleInputChange}
                placeholder="owner_id" readOnly/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="tag" className="col-sm-2 control-label">tag:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="tag"
                value={this.state.tag}
                onChange={this.handleInputChange}
                placeholder="tag" />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="title" className="col-sm-2 control-label">title:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="title"
                value={this.state.title}
                onChange={this.handleInputChange}
                placeholder="title" />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="description" className="col-sm-2 control-label">description:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="description"
                value={this.state.description}
                onChange={this.handleInputChange}
                placeholder="description" />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="date_created" className="col-sm-2 control-label">date_created:</label>
            <div className="col-sm-4">
              <DatePicker
                className="form-control"
                type="text"
                name="date_created"
                selected={this.state.date_created}
                onChange={this.handleDateChange}
                // showTimeSelect
                dateFormat="DD/MM/YYYY h:mm"
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="status" className="col-sm-2 control-label">status:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="status"
                value={this.state.status}
                onChange={this.handleInputChange}
                placeholder="status" />
            </div>
          </div>
          <div className="form-group">
            <div className="col-sm-offset-2 col-sm-10">
              <button type="submit" className="btn btn-primary">Edit</button>
            </div>
          </div>

        </form>
      </div>
    }


    return (
      <div>
          {content}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/PublisherPage/PublisherPageEdit.js